export const FONT_OPTIONS = [
  {
    id: "sans",
    preview: "Aa",
    family: "font-sans",
    desc: "Limpia",
  },
  {
    id: "serif",
    preview: "Aa",
    family: "font-serif",
    desc: "Premium",
  },
  {
    id: "mono",
    preview: "Aa",
    family: "font-mono",
    desc: "Precisa",
  },
];
